export enum ISSUE_STATUS {
  ISSUE_OPEN = "ISSUE_OPEN",
  ISSUE_ASSIGNED = "ISSUE_ASSIGNED",
  ISSUE_CLOSED = "ISSUE_CLOSED",
  ISSUE_INSERVICE = "ISSUE_INSERVICE",
  ISSUE_RESOLVED = "ISSUE_RESOLVED",
}
